import React from 'react';
import PropTypes from 'prop-types';
import styles from './bar-chart.module.scss';
import { colorMatcher, humanizeNumber } from '../../helpers/formatters';
import TextBarChart from './text-barchart';
import Legend from './legend';
import { labelMatcher } from '../../helpers/label-mapper';

const getTickWidth = (min, max, value) => {
  const scaleLength = max - min;
  return scaleLength > 0 ? (value - min) / scaleLength : 0;
};

export class BarChart extends React.Component {
  constructor() {
    super();
    this.state = {
      firstDraw: true,
    };
  }

  componentWillUpdate(nextProps) {
    if (nextProps.visible && this.state.firstDraw) {
      requestAnimationFrame(() => {
        this.setState({
          firstDraw: false,
        });
      });
    }
  }

  renderLegend() {
    const { data, unit, children, title } = this.props;
    return data.legendHidden ? null : (
      <Legend
        min={data.min}
        max={data.max}
        unit={unit}
        children={children}
        title={title}
      />
    );
  }

  renderTick(tickWidth) {
    const { tickIsHidden, unit, color, data } = this.props;
    return (
      <div
        style={{
          backgroundColor: tickIsHidden ? 'transparent' : colorMatcher(color),
        }}
        className={styles.barChartTick}
      >
        <div className={styles.barChartTickInner} data-edge={tickWidth > 0.9}>
          <div
            style={{
              color: colorMatcher(color),
              transform:
                data.value <= 10 ? `translate(-30%, 0)` : `translate(-50%, 0)`,
            }}
            className={styles.barChartTickValue}
          >
            {humanizeNumber(data.value, unit)}
          </div>
        </div>
      </div>
    );
  }

  renderForeground(tickWidth) {
    const { visible, tickIsHidden, color } = this.props;
    return visible ? (
      <div
        style={{
          width: `${tickWidth * 100}%`,
          backgroundColor: !tickIsHidden ? colorMatcher(color) : 'transparent',
        }}
        className={`${styles.barChartForeground} ${
          !tickIsHidden && styles.barChartForegroundActive
        }`}
      >
        {this.renderTick(tickWidth)}
      </div>
    ) : null;
  }
  isTextBarChart(data) {
    return data.max === 'High';
  }

  render() {
    const { data, children, tickIsHidden, title } = this.props;
    const { min, max, value } = data;
    if (this.isTextBarChart(data)) return <TextBarChart data={data} />;
    var tickWidth = this.state.firstDraw ? 0 : getTickWidth(min, max, value);
    return (
      <div className={styles.barChart + ' barChart'}>
        <div className={styles.barChartTitle}>
          {title === 'Power stations'
            ? 'Capacity of power station'
            : labelMatcher(children[1])}
        </div>
        <div className={styles.bartChartWrapper}>
          <div className={styles.barChartBackground}>
            {this.renderForeground(tickWidth)}
          </div>
          {!tickIsHidden && this.renderLegend()}
        </div>
      </div>
    );
  }
}

BarChart.propTypes = {
  data: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  tickIsHidden: PropTypes.bool,
  visible: PropTypes.bool.isRequired,
};

export class MedianBarChart extends React.Component {
  constructor() {
    super();
    this.state = {
      firstDraw: true,
    };
  }

  componentWillUpdate(nextProps) {
    if (nextProps.visible && this.state.firstDraw) {
      requestAnimationFrame(() => {
        this.setState({
          firstDraw: false,
        });
      });
    }
  }

  renderForeground(tickWidth) {
    const { visible, color, data, unit } = this.props;
    const cssColor = colorMatcher(color);
    return visible ? (
      <div
        style={{ width: `${tickWidth * 100}%` }}
        className={styles.medianBarChartForeground}
      >
        <div
          style={{
            background: `repeating-linear-gradient(
            to bottom,
            ${cssColor},${cssColor} 4px,
            white 4px,white 7px
           )`,
          }}
          className={styles.medianBarChartTick}
        >
          <div className={styles.barChartTickInner} data-edge={tickWidth > 0.9}>
            <div
              style={{ color: cssColor }}
              className={styles.medianBarChartTickValue}
            >
              {humanizeNumber(data.value, unit)}
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
  renderLegend() {
    const { data, unit } = this.props;
    return data.legendHidden ? null : (
      <div className={styles.barChartLegend}>
        <div>{humanizeNumber(data.min, unit)}</div>
        <div>{humanizeNumber(data.max, unit)}</div>
      </div>
    );
  }

  render() {
    const { data, children } = this.props;
    const { min, max, value } = data;
    var tickWidth = this.state.firstDraw ? 0 : getTickWidth(min, max, value);
    return (
      <div className={styles.medianBarChartWrapper + ' barChart'}>
        <div className={styles.medianBarChartLegend}>{children}</div>

        <div className={styles.medianBarChartBackground}>
          {this.renderForeground(tickWidth)}
        </div>
        {this.renderLegend()}
      </div>
    );
  }
}

MedianBarChart.propTypes = {
  data: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  tickIsHidden: PropTypes.bool,
  visible: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/bar-chart/bar-chart.js